import { Project } from '../../api';

export type ProjectShape = {
  projects: Project[];
  selectedIds: Project['id'][];
  loading: boolean;
  expanded: boolean;
};

export const ALL_PROJECTS_ID: Project['id'] = 0;

export const sortProjects = (a: Project, b: Project) =>
  a.name.toLowerCase().localeCompare(b.name.toLowerCase());
